import { render, staticRenderFns } from "./invoices.vue?vue&type=template&id=782f8cb6&"
import script from "./invoices.vue?vue&type=script&lang=js&"
export * from "./invoices.vue?vue&type=script&lang=js&"
import style0 from "./invoices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports